import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderVendorBranchResponse,
  IInventoryPurchaseOrderVendorBranchResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const usePurchaseOrderVendorBranchAPI = () => {
  const [purchaseOrderVendorBranch, setPurchaseOrderVendorBranch] = useState<
    IInventoryPurchaseOrderVendorBranchResponseData[]
  >([]);
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (vendorId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IInventoryPurchaseOrderVendorBranchResponse> = await axios.get(
          `${INVENTORY_MODULE?.PURCHASE_ORDER_VENDOR_BRANCH?.baseURL}${vendorId}/`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data.status === true) {
          setPurchaseOrderVendorBranch(res.data.data);
        } else {
          setPurchaseOrderVendorBranch([]);
        }
      } catch (error: any) {
        setPurchaseOrderVendorBranch([]);
        if (axios.isAxiosError(error)) {
          sendCurl(error.config["curlCommand"]);
          captureError(error);
        } else {
          toast.error("Server Error");
        }
      }
    },
    [configuration],
  );

  return { execute, purchaseOrderVendorBranch };
};
